import 'core-js/stable';
import 'regenerator-runtime/runtime';
//import './style.css'; // inables css styles for the old kiwi app

import('./bootstrap');
